const siteName = "Guardhart Security Services"

const onProduction = false

// const baseUrl = onProduction ? 'https://guardhart.co.ke' : 'http://127.0.0.1:8000'
const baseUrl = ""

const api = '/api/v1/'

const multipartHeader = { "Content-Type": "multipart/form-data" }

const toastError = "Something Went Wrong"

const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const makeProfileLetter = (user) => {
    const mail = user?.email
    if (!mail) {
        return 'S'
    }
    const letter = mail.charAt(0)
    return letter.toUpperCase()
}
const toasterPosition = "bottom-center"

const toasterOptions = {
    className: "rounded-md border"
}

const errorMsg = "Something Went Wrong"

const getPageValue = (url) =>{
    const urlString = url.split("?")[1]
    const param = new URLSearchParams(urlString)
    return param.get("page")
}

const getCurrentPage = (previous, next) => {
    if (next !== null) {
        const nextPage = getPageValue(next)
        return parseInt(nextPage) - 1
    } else {
        if (previous !== null) {
            const previousPage = getPageValue(previous)
            if(isNaN(parseInt(previousPage))){
                return 2
            }
            return parseInt(previousPage) + 1
        }
        if (next === null && previous === null) {
            return 1
        }
    }
}

const changeUrlPageParam = (
    value, value_type, hasFiltered,
    setHasFiltered, filterCtx, setSearchParams) => {
    if (!hasFiltered) {
        setHasFiltered(true)
    }
    if (value_type === "model") {
        filterCtx.setModelFilter(value)
    } else if (value_type === "brand") {
        filterCtx.setBrandFilter(value)
    }
    if (value) {
        setSearchParams((params) => {
            params.set(value_type, value)
            return params
        })
    } else {
        setSearchParams((params) => {
            params.delete(value_type)
            return params
        })
    }
}

function formatMinutes(minutes) {
    if (minutes >= 60) {
        var hours = Math.floor(minutes / 60);
        var remainingMinutes = minutes % 60;
    
        var hoursString = hours < 10 ? '0' + hours : hours;
        var minutesString = remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes;
    
        return hoursString + 'hr ' + minutesString + ' mins';
    } else {
        return Math.floor(minutes) + ' mins';
    }
}

const isUrl = (text) => {
    const str = String(text)
    return str.toLowerCase().includes('http')
}

const getImageUrl = (url) => {
    if (isUrl(url)) {
        return url
    }
    return baseUrl + url
}

const utils = {
    siteName,
    multipartHeader,
    baseUrl,
    api,
    toCommas,
    makeProfileLetter,
    toasterPosition,
    toasterOptions,
    errorMsg,
    getCurrentPage,
    getPageValue,
    changeUrlPageParam,
    toastError,
    formatMinutes,
    getImageUrl,
}


export default utils